import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import homeImage from '../../../assets/images/homeimg.jpg';

const HeroSection = () => {
  return (
    <div className="relative overflow-hidden bg-gray-50">
      {/* Main Hero Section with Overlay */}
      <div 
        className="relative min-h-[90vh] bg-cover bg-center flex items-center"
        style={{ backgroundImage: `url(${homeImage})` }}
      >
        <div className="absolute inset-0 bg-primary/20 backdrop-blur-[2px]"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <motion.span
              className="inline-block bg-primary text-white px-4 py-2 rounded-md text-sm font-medium mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Bienvenue au Groupe Scolaire Sanaa
            </motion.span>

            <motion.h1
              className="text-4xl md:text-display font-bold text-white mb-4 leading-tight"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              Une éducation d'excellence pour l'avenir de votre enfant
            </motion.h1>

            <motion.p
              className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              Notre établissement offre un enseignement de qualité de la maternelle au lycée, préparant les élèves à réussir dans un monde en constante évolution.
            </motion.p>

            <motion.div
              className="flex flex-wrap gap-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.8 }}
            >
              <Button to="/notre-ecole" variant="primary" size="large">
                Découvrir notre école
              </Button>
              <Button to="/contact" variant="outline-white" size="large">
                Nous contacter
              </Button>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Curved bottom edge */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0L48 8.875C96 17.75 192 35.5 288 53.25C384 71 480 88.75 576 84.875C672 81 768 55.5 864 44.375C960 33.25 1056 36.5 1152 48.625C1248 60.75 1344 81.75 1392 92.25L1440 102.75V120H1392C1344 120 1248 120 1152 120C1056 120 960 120 864 120C768 120 672 120 576 120C480 120 384 120 288 120C192 120 96 120 48 120H0V0Z" fill="white" />
        </svg>
      </div>
    </div>
  );
};

export default HeroSection;